import { Effect, Reducer, history } from 'umi';
import { notification } from 'antd';
import {
    getVoucherTypes,
    getTramitTypes,
    getReceiptTypes,
    getDocumentTypes,
    getAffiliateFile,
    getFile,
    hasPendingDocuments,
    getFilesShort,
    getCoveragesPerFile,
    uploadFileAttachment,
    getDispositions,
    canRequestPartialPayment,
} from '@/services/files.service';
import { checkAllowanceLimit } from '@/services/affiliates.service';
import {
    getTicketOcurrencies,
    getReceiptOcurrencies,
    getVoucherOcurrencies,
} from '@/services/consumptions.service';

const Model = {
    namespace: 'partialsPaymentsRequests',
    state: {
        file: null,
        limit: null,
        pendingDocuments: false,
        voucherTypes: [],
        receiptTypes: [],
        tramitTypes: [],
        documentTypes: [],
        receiptsToLoad: [],
        vouchersToLoad: [],
        ticketsToLoad: [],
        othersToLoad: [],
        coverages: [],
        period: null,
        selectedCoverages: {},
        dispositions: [],
        exceptionalMonths: {},
        hasValidOrigin: false,
    },

    effects: {
        *validateCanRequestPartialPayment({ payload }, { call, put }) {
            try {
                const response = yield call(canRequestPartialPayment, payload);
                yield put({ type: 'show', payload: { hasValidOrigin: true } });
                return { success: true, response };
            } catch (error) {
                yield put({ type: 'show', payload: { hasValidOrigin: false } });
                return { success: false, error };
            }
        },

        *fetchFile({ payload }, { call, put }) {
            const { id, affiliate } = payload;

            let file;
            let pendingDocuments;

            try {
                if (affiliate) {
                    const fileResponse = yield call(getAffiliateFile, affiliate, id);
                } else {
                    const fileResponse = yield call(getFile, id);
                    pendingDocuments = yield call(hasPendingDocuments, id);
                    file = fileResponse.data;
                }
                yield put({
                    type: 'show',
                    payload: {
                        file,
                        pendingDocuments: pendingDocuments?.data,
                    },
                });
                yield put({
                    type: 'fetchFileResolutions',
                    payload: { file: id }
                });
            } catch (error) {
                notification.error({
                    message:
                        error?.response?.data?.detail ??
                        'Ocurrió un error al cargar los datos de esta pantalla.',
                });
            }
        },

        *fetchFilesShort({ payload }, { call, put }) {
            try {
                const response = yield call(getFilesShort, payload);
                yield put({
                    type: 'show',
                    payload: { filesShort: response.data },
                });
            } catch (error) {
                console.log(error);
            }
        },

        *fetchCoverages({ payload }, { call, put }) {
            try {
                const response = yield call(getCoveragesPerFile, payload.id)
                yield put({
                    type: 'show',
                    payload: { coverages: response.data ?? [] }
                })
            } catch (error) { console.warn('Error al cargar las coberturas') }
        },

        *fetchFileResolutions({ payload }, { call, put }) {
            const { file } = payload;
            try {
                const response = yield call(getDispositions, file);
                yield put({
                    type: 'show',
                    payload: { dispositions: response.data.results },
                });
            } catch (error) { console.warn('Error al cargar las disposiciones') }
        },

        *fetchTypeData(_, { put, all }) {
            yield all([
                put({ type: 'fetchVoucherTypes' }),
                put({ type: 'fetchReceiptTypes' }),
                put({ type: 'fetchFileTypes' }),
            ]);
        },

        *fetchFileTypes(_, { call, put }) {
            try {
                const response = yield call(getTramitTypes);
                yield put({
                    type: 'show',
                    payload: { tramitTypes: response.data },
                });
            } catch (error) {
                notification.error({
                    message:
                        error?.response?.data?.detail ??
                        'Ocurrió un error al cargar los datos de esta pantalla.',
                });
            }
        },

        *fetchReceiptTypes(_, { all, call, put }) {
            try {
                const [recResponse, docResponse] = yield all([
                    call(getReceiptTypes),
                    call(getDocumentTypes),
                ]);

                yield put({
                    type: 'show',
                    payload: {
                        receiptTypes: recResponse?.data ?? [],
                        documentTypes: docResponse ?? [],
                    },
                });
            } catch (error) {
                notification.error({
                    message:
                        error?.response?.data?.detail ??
                        'Ocurrió un error al cargar los datos de esta pantalla.',
                });
            }
        },

        *fetchVoucherTypes(_, { all, call, put }) {
            try {
                const [response] = yield all([call(getVoucherTypes)]);
                yield put({
                    type: 'show',
                    payload: { voucherTypes: response?.data ?? [] },
                });
            } catch (error) {
                notification.error({
                    message:
                        error?.response?.data?.detail ??
                        'Ocurrió un error al cargar los datos de esta pantalla.',
                });
            }
        },


        *addTicketToLoad({ payload }, { put, select, call }) {
            const { ticketsToLoad } = yield select(state => state.partialsPaymentsRequests);
            const docObj = payload?.documents || payload?.ocuments || payload;
            const document_file = payload?.document_file;
            const pkVal = docObj?.pk || docObj?.id;
            let duplicates = docObj?.duplicates;
            if (duplicates === undefined) {
                try {
                    if (pkVal) {
                        const response = yield call(getTicketOcurrencies, pkVal);
                        duplicates = response.data;
                    } else {
                        duplicates = 0;
                    }
                } catch (error) {
                    console.error(error);
                    duplicates = 0;
                }
            }
            yield put({
                type: 'show',
                payload: { ticketsToLoad: [...ticketsToLoad, { ...docObj, document_file, duplicates }] },
            });
        },
        *removeTicketToLoad({ payload }, { put, select }) {
            const { ticketsToLoad } = yield select(state => state.partialsPaymentsRequests);
            const newTickets = [...ticketsToLoad];
            newTickets.splice(payload, 1);
            yield put({
                type: 'show',
                payload: { ticketsToLoad: newTickets },
            });
        },
        *addReceiptToLoad({ payload }, { put, select, call }) {
            const { receiptsToLoad } = yield select(state => state.partialsPaymentsRequests);
            const docObj = payload?.documents || payload?.ocuments || payload;
            const document_file = payload?.document_file;
            const pkVal = docObj?.pk || docObj?.id;

            let duplicates = docObj?.duplicates;
            if (duplicates === undefined) {
                try {
                    if (pkVal) {
                        const response = yield call(getReceiptOcurrencies, pkVal);
                        duplicates = response.data;
                    } else {
                        duplicates = 0;
                    }
                } catch (error) {
                    console.error(error);
                    duplicates = 0;
                }
            }
            yield put({
                type: 'show',
                payload: { receiptsToLoad: [...receiptsToLoad, { ...docObj, document_file, duplicates }] },
            });
        },
        *removeReceiptToLoad({ payload }, { put, select }) {
            const { receiptsToLoad } = yield select(state => state.partialsPaymentsRequests);
            const newReceipts = [...receiptsToLoad];
            newReceipts.splice(payload, 1);
            yield put({
                type: 'show',
                payload: { receiptsToLoad: newReceipts },
            });
        },
        *addVoucherToLoad({ payload }, { put, select, call }) {
            const { vouchersToLoad } = yield select(state => state.partialsPaymentsRequests);
            const docObj = payload?.documents || payload?.ocuments || payload;
            const document_file = payload?.document_file;
            const pkVal = docObj?.pk || docObj?.id;
            let duplicates = docObj?.duplicates;
            if (duplicates === undefined) {
                try {
                    if (pkVal) {
                        const response = yield call(getVoucherOcurrencies, pkVal);
                        duplicates = response.data;
                    } else {
                        duplicates = 0;
                    }
                } catch (error) {
                    console.error(error);
                    duplicates = 0;
                }
            }
            yield put({
                type: 'show',
                payload: { vouchersToLoad: [...vouchersToLoad, { ...docObj, document_file, duplicates }] },
            });
        },
        *removeVoucherToLoad({ payload }, { put, select }) {
            const { vouchersToLoad } = yield select(state => state.partialsPaymentsRequests);
            const newVouchers = [...vouchersToLoad];
            newVouchers.splice(payload, 1);
            yield put({
                type: 'show',
                payload: { vouchersToLoad: newVouchers },
            });
        },
        *addOtherToLoad({ payload }, { put, select, call }) {
            const { othersToLoad, file } = yield select(state => state.partialsPaymentsRequests);
            const { rawFile, requirement, uid } = payload;

            const formData = new FormData();
            formData.append('attachment', rawFile, rawFile.name);
            if (requirement?.pk) {
                formData.append('type', requirement.pk.toString());
            }
            formData.append('observation', "");
            formData.append('file', file.id.toString());

            try {
                const response = yield call(uploadFileAttachment, file.affiliate.id, formData);
                const uploadedDoc = {
                    ...response.data,
                    uid: rawFile?.uid,
                };
                yield put({
                    type: 'show',
                    payload: { othersToLoad: [...othersToLoad, uploadedDoc] },
                });
                if (payload.onSuccess) {
                    payload.onSuccess(uploadedDoc);
                }
            } catch (error) {
                notification.error({
                    message:
                        error?.response?.data?.detail ??
                        'Error al subir el documento.',
                });
                if (payload.onError) {
                    payload.onError(error);
                }
            }
        },
        *removeOtherToLoad({ payload }, { put, select }) {
            const { othersToLoad } = yield select(state => state.partialsPaymentsRequests);
            const targetUid = payload?.uid;
            const targetPk = payload?.pk || payload?.response?.pk || payload?.id || payload?.response?.id;

            const newOthers = othersToLoad.filter((item, idx) => {
                if (typeof payload === 'number') {
                    return idx !== payload;
                }
                if (targetUid && item.uid && item.uid === targetUid) {
                    return false;
                }
                if (targetPk && (item.pk || item.id) && (item.pk ?? item.id) === targetPk) {
                    return false;
                }
                return true;
            });

            yield put({
                type: 'show',
                payload: { othersToLoad: newOthers },
            });
        },

    },

    reducers: {
        show(state, { payload }) {
            return { ...state, ...payload };
        },

        resetState() {
            return {
                file: null,
                limit: null,
                pendingDocuments: false,
                voucherTypes: [],
                receiptTypes: [],
                tramitTypes: [],
                documentTypes: [],
                receiptsToLoad: [],
                vouchersToLoad: [],
                ticketsToLoad: [],
                othersToLoad: [],
                coverages: [],
                period: null,
                selectedCoverages: {},
                dispositions: [],
                exceptionalMonths: {},
            };
        },
    },
};

export default Model;
